module.exports = __webpack_public_path__ + "img/docs-info-2.3709f874.jpg";